import { addValidationRule } from '@akihirotakamura/formsy-react'

addValidationRule('isHalfKana', (values, value) => {
  if (!value || value === '') return true
  return value.match(/^[\uff66-\uff9f]*$/)
})
